import { COMMON_IMG } from '@client/constants/common-url'
import React from 'react'
import './index.scss'

const App = (): JSX.Element => {
  return (
    <div className="offline">
      <img className="offline-icon" src={COMMON_IMG.HUO_BAO_ICON} alt="" />
      <div className="offline-text">2023美团年度报告活动已结束，明年见</div>
    </div>
  )
}

export default App